import { extractHttpErrorMessage } from './http-error-message';
import { readVioDataField } from './vio-api-response';

/** Rows returned from seed / materialize / step 3 when something is wrong but processing continues. */
export interface SeedIssueRow {
  kind?: string;
  slideSrNo?: number | null;
  projectSlideId?: number | null;
  lessonSlideId?: string | null;
  templateLineSrno?: number | string | null;
  ogLineSrno?: number | null;
  psSrNo?: number | null;
  lineName?: string | null;
  message?: string;
}

export function formatSeedIssuesText(issues: SeedIssueRow[] | undefined | null): string {
  if (!issues?.length) return '';
  const lines = issues.map((i, idx) => {
    const loc: string[] = [];
    if (i.slideSrNo != null && Number.isFinite(Number(i.slideSrNo))) {
      loc.push(`slide #${i.slideSrNo}`);
    }
    if (i.projectSlideId != null) loc.push(`project slide id ${i.projectSlideId}`);
    if (i.lessonSlideId) loc.push(`lesson slide ${i.lessonSlideId}`);
    const lineParts: string[] = [];
    if (i.templateLineSrno != null && i.templateLineSrno !== '') lineParts.push(`template line ${i.templateLineSrno}`);
    if (i.ogLineSrno != null) lineParts.push(`OG line ${i.ogLineSrno}`);
    if (i.psSrNo != null) lineParts.push(`project line SR ${i.psSrNo}`);
    if (i.lineName) lineParts.push(`"${i.lineName}"`);
    const where = [...loc, ...lineParts].join(', ');
    const msg = i.message || i.kind || 'Issue';
    return `${idx + 1}. ${where ? `${where}: ` : ''}${msg}`;
  });
  return `Issues (${issues.length}):\n\n${lines.join('\n\n')}`;
}

/**
 * One blocking dialog: summary plus any structured seed issues. After OK the caller continues (reload, etc.).
 * If `summary` is set it is shown instead of `data.message` to avoid duplicate lines when both say the same thing.
 */
export function alertSeedingResult(data: { message?: string; seedIssues?: SeedIssueRow[] } | null | undefined, summary?: string): void {
  const built = summary != null && String(summary).trim() !== '' ? String(summary).trim() : '';
  const fallback = data?.message != null && String(data.message).trim() !== '' ? String(data.message).trim() : '';
  const main = built || fallback;
  const issuesBlock = formatSeedIssuesText(data?.seedIssues);
  const body = [main, issuesBlock].filter((p) => p && String(p).trim()).join('\n\n');
  alert(body || 'Done.');
}

/** Parse error payload from failed HTTP (e.g. 500) after ApplicationSuccess wrapper. */
export function alertSeedingHttpError(err: any): void {
  const raw = err?.error;
  const nested = readVioDataField(raw);
  const data =
    nested != null && typeof nested === 'object'
      ? nested
      : raw && typeof raw === 'object'
        ? (raw as Record<string, unknown>)
        : null;
  const msg = extractHttpErrorMessage(err);
  const seedIssues = data && typeof data === 'object' ? (data as { seedIssues?: SeedIssueRow[] }).seedIssues : undefined;
  alertSeedingResult({ message: String(msg), seedIssues });
}
